import { apiv2Url } from './config';
import { postPromise } from './utils';

export const requestConnection = (): Promise<{ token: string }> =>
  postPromise(`${apiv2Url}/ws`, {});
